// For some reason, the import of scoped modules doesn't work with typescript,
// therefore this file currently keeps the .js ending. Otherwise, sentry JS logging breaks.
// See https://stackoverflow.com/questions/47038875/cant-import-typescript-module
import * as Sentry from '@sentry/browser';

class SentryHelper{

    /**
     * Init Sentry if not in development env
     *
     * @returns Sentry
     */
    constructor(){
        const sentryData = $('.sl-js-layout').data('sentry');
        this.apiKey = sentryData.apiKey;
        if (this.apiKey){
            Sentry.init({dsn: this.apiKey});
            Sentry.configureScope(scope => {
                scope.setTags(sentryData.scope.tags);
                scope.setUser(sentryData.scope.user);
            });
        }
    }

    /**
     * Return Sentry module
     */
    getSentry (){
        return Sentry;
    }

    /**
     * Captures a message event and sends it to Sentry or to console if in development
     *
     * @param message The message to send to Sentry.
     * @param level Define the level of the message.
     * @param context Any kind of data. This data will be normailzed.
     */
    log(message, level, context) {
        if (this.apiKey) {
            Sentry.withScope(function(scope) {
                scope.setLevel(level);
                if (typeof context !== 'undefined'){
                    scope.setContext('js-context',{context});
                }
                Sentry.captureMessage(message);
            });
        } else {
            console.log(message);
            console.log(JSON.stringify(context, null, 2));
        }
    }
}

export default new SentryHelper();